namespace $.$$ {
    $mol_style_define($bog_theme_picker_row, {
        '@': {
            bog_theme_picker_row_focused: {
                true: {
                    background: {
                        color: $mol_theme.hover,
                    },
                    boxShadow: `inset 0 0 0 1px #000, inset 0 0 0 2px #fff`,
                },
            },
        },
    })
}
